<template>
	<div class="help-container">
		<div class="help-menu">
			<help-menu></help-menu>
		</div>
		<div class="help-page">
			<help-page></help-page>
		</div>
	</div>
</template>

<script>
	import HelpMenu from './HelpMenu.vue'
	import HelpPage from './HelpPage.vue'
	
	export default{
		name:'HelpHome',
		components:{
			HelpMenu,
			HelpPage
		},
		data(){
			return{
				
			}
		}
	}
</script>

<style>
	.help-container{
		width: 100%;
		height: 100%;
		position: relative;
		overflow: hidden;
	}
	.help-container .help-menu{
		position: absolute;
		top: 0;
		left: 0;
		bottom: 0;
		width: 300px;
		overflow: hidden;
	}
	.help-container .help-page{
		position: absolute;
		top: 0;
		right: 0;
		bottom: 0;
		left: 300px;
		overflow: hidden;
	}
</style>
